// ⚠️ AUTO-GENERATED — DO NOT EDIT MANUALLY
// Source: ./svg/IconBondManager.svg — regenerate with `nx run creditflowresearch-uilib:icons-generate --write`
import BaseIcon from './BaseIcon';
import type { IIconProps } from './types';

const IconBondManager = (props: IIconProps) => (
  <BaseIcon viewBox="0 0 16 16" fill="currentColor" { ...props }>
    <path d="M11.7647 2.15917L9.90585 0L2.87058 8.27682L0 5.53633V16L11.7647 2.15917Z" />
    <path d="M4.51758 13.6748L6.3764 15.8617L13.4117 7.58488L15.9999 10.6575V0.193877L4.51758 13.6748Z" />
  </BaseIcon>
);

export default IconBondManager;
